import type { CategoryLinkObject } from '@/types/generated';

/** Links without an image render as text; a dead image rewrite placeholder resolves to '' and falls back to text too. */
export function textCategoryLinks(links: CategoryLinkObject[]): CategoryLinkObject[] {
    return links.filter((link: CategoryLinkObject) => !link.image_url);
}
